<div class="container">
  <div class="question">{{ chatService.trivia?.current?.question }}</div>
  <div class="input-group">
    <input type="text" placeholder="Enter your best guess..." [(ngModel)]="answer" (keypress)="answerTrivia($event)" #chatInput />
    <div class="right">
      <button class="send-button" (click)="answerTrivia(null)">
        <app-icon icon="send" />
      </button>
    </div>
  </div>
  <div class="info">
    <span class="amount">
      <app-icon icon="coin" />
      <app-currency [value]="chatService.trivia.current.amount" [size]="14"></app-currency>
    </span>
    <span class="user">
      <img class="avatar" [ngSrc]="chatService.trivia.current.avatar" width="15" height="15" />
      {{ chatService.trivia.current.by | name }}
    </span>
  </div>
</div>
